/* eslint-disable no-empty */
import { BasketballTeamProfile } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const basketballTeamsApi = createApi({
  reducerPath: 'basketballTeamsApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchTeam: builder.query<BasketballTeamProfile, number>({
      query: (request) => `v2/basketball/teams/${request}/profile`,
    }),
  }),
});

// Export hooks for usage in functional components
export const { reducerPath, reducer, middleware, useFetchTeamQuery } =
  basketballTeamsApi;
